import { jwtDecode } from "jwt-decode";

export interface DecodedToken {
  sub_id?: string
  group_ids?: string[] | string
  [key: string]: any // to allow other fields dynamically
}

/**
 * Extracts fields from a JWT token.
 * @param token - The JWT token string (e.g., from apiGetStellarSearchToken()).
 * @param fields - Optional array of field names to extract. Returns all if not provided.
 * @returns An object containing the requested fields, or an empty object if invalid token.
 */
export function extractFieldsFromToken(token: string | null, fields?: string[]): Record<string, any> {
  try {
    if (!token) throw new Error('Empty token')

    const decoded: DecodedToken = jwtDecode(token)

    if (!fields || fields.length === 0) {
      return decoded // return everything if specific fields not requested
    }

    const extracted: Record<string, any> = {}
    for (const field of fields) {
      if (field in decoded) {
        extracted[field] = decoded[field]
      }
    }

    return extracted
  } catch (error) {
    console.error('Invalid token or decoding error:', error)
    return {}
  }
}
